import * as React from 'react';
import { observer } from 'mobx-react';
import Modal from '../../../../../Modal';
import { T } from '../../../../../../Translations';
import ModalStore from '../../../../../Modal/Store';

export interface Props {
  modalStore: ModalStore;
}

const ExeconlineCatalogModal: React.FC<Props> = ({ modalStore }) => {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={modalStore.close}
          title={
            <h3 className="p-4 text-xl font-semibold">
              <T kind="Essentials Catalog" />
            </h3>
          }
          customBackgroundCssClasses="bg-teal-100 opacity-60"
        >
          <p className="pb-4">
            <T kind="Along with your curated collection, participants ..." />
          </p>
          <p className="pb-4">
            <T kind="The Essentials catalog includes 100+ high-impact ..." />
          </p>
        </Modal>
      );
  }
};

export default observer(ExeconlineCatalogModal);
